var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2252 1.40795C10.6154 1.01707 11.2482 1.01678 11.6387 1.4073L13.7556 3.52413C14.1461 3.91466 14.1464 4.54811 13.7562 4.939L6.83066 11.8774C6.6952 12.0131 6.52362 12.107 6.33635 12.1478L3.63407 12.7372C2.92328 12.8922 2.2904 12.2595 2.44438 11.5479L3.02996 8.84156C3.07055 8.65396 3.1642 8.48201 3.29974 8.34622L10.2252 1.40795Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28516 3.7041L11.8162 7.23515",
    stroke: "#A3A3A3",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49414 16.8481H13.9941",
    stroke: "#A3A3A3",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGray);
export default __webpack_public_path__ + "static/media/editGray.8bf4d6b99eeb7ac14c345fce53670363.svg";
export { ForwardRef as ReactComponent };